import { gql } from 'apollo-boost';
import { HydratedCurriculumType } from '../Common/types/AppConfigTypes';
import { capitalize } from '../Common/utils';

export interface GetContentRevisionQueryFilters {
    skip?: number;
    take?: number;
    startsWith?: string;
    searchTerm?: string;
    dynamicFilters: { [k: number]: string }; // fixme, an object
}

export interface GetContentRevisionsOpts {
    activeCurriculumType?: HydratedCurriculumType;
    filters: GetContentRevisionQueryFilters;
}

export const listQuery = (opts: GetContentRevisionsOpts) => {
    if (!opts.activeCurriculumType) {
        console.error('Cannot query list without active curriculum type.');
        return;
    }

    const queryName = getListQueryName(opts.activeCurriculumType);
    const { header, description } = opts.activeCurriculumType.listView;
    const args = getArgString(opts.filters);

    return gql`{ ${queryName} (${args}) {
        pageTotal
        results {
            uuid
            ${header.field.slug}
            ${description.field.slug}
        }
    }}`;
};

export const getListQueryName = (curriculumType?: HydratedCurriculumType) => {
    if (!curriculumType) {
        return '';
    }
    return `many${capitalize(curriculumType.contentType.slug)}`;
};
const getArgString = (filters: GetContentRevisionQueryFilters) => {
    const argStrings = [];

    if (filters.skip !== undefined) {
        argStrings.push(`skip: ${filters.skip}`);
    }

    if (filters.take !== undefined) {
        argStrings.push(`take: ${filters.take}`);
    }

    if (filters.startsWith !== undefined) {
        argStrings.push(`startsWith: "${filters.startsWith}"`);
    }

    if (filters.searchTerm !== undefined && filters.searchTerm !== '') {
        argStrings.push(`search: "${filters.searchTerm}"`);
    }

    if (filters.dynamicFilters && Object.keys(filters.dynamicFilters).length) {
        const filterString = formatDynamicFilterString(filters.dynamicFilters);
        argStrings.push(filterString);
    }

    argStrings.push(`orderBy: ASC`);

    return argStrings.join(', ');
};

//eslint-disable-next-line
const formatDynamicFilterString = (dynamicFilters: any) => {
    return `filter: {
    ${Object.keys(dynamicFilters)
        .map(key => {
            if (typeof dynamicFilters[key] === 'object') {
                const linkObject = dynamicFilters[key];

                return `${key}: {
                ${Object.keys(linkObject)
                    .map(
                        linkObjectKey =>
                            `${linkObjectKey}: "${linkObject[linkObjectKey]}"`,
                    )
                    .join('\n')}
            }`;
            } else {
                return `${key}: "${dynamicFilters[key]}"`;
            }
        })
        .join('\n')}
    }`;
};

export const listItemPageQuery = (uuid: string) => gql`{
    pageByContentRevision(contentRevisionUuid: "${uuid}") {
        path
        catalogContentRevisionUuid
    }
}`;

export const combineDynamicFilters = (
    dynamicFilterValues: { [k: number]: string } = {},
    curriculumType: HydratedCurriculumType,
) => {
    const dynamicFilterConfig = curriculumType.filters;
    //eslint-disable-next-line
    const result: any = {};

    dynamicFilterConfig.forEach((filter, index) => {
        const isLinkFilter =
            filter.linkedTo.contentType.slug !==
            curriculumType.contentType.slug;
        const value = dynamicFilterValues[index];
        let key;

        if (value === undefined) {
            return;
        }

        if (!isLinkFilter) {
            key = filter.linkedTo.field.slug;

            if (key !== undefined) {
                result[key] = value;
            }
        } else {
            const linkField = curriculumType.contentType.fields.find(
                field =>
                    field.controls.linkUuid ===
                    filter.linkedTo.contentType.uuid,
            );
            key = linkField && linkField.slug;
            const innerKey = filter.linkedTo.field.slug;

            if (key !== undefined && innerKey !== undefined) {
                if (result[key] === undefined) {
                    result[key] = {};
                }
                result[key][innerKey] = value;
            }
        }
    });
    return result;
};
